<template>
  <div>
    <b-row style="margin-top: 25px;">
      <b-col sm="3">
        <b-img
          thumbnail
          fluid
          src="https://picsum.photos/250/250/?image=54"
          alt="Image 1"
        ></b-img>
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <h2>{{ deviceName }}</h2>
          </b-col>
          <b-col>
            <h5 class="float-right">
              <date-format-toggle :date="createdAt" />
            </h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h4>Grandma</h4>
          </b-col>
          <b-col>
            <h5 class="float-right">
              {{ trigger }}
            </h5>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DateFormatToggle from "@/components/common/dateFormatToggle";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
export default {
  name: "Display_VideoRow",
  components: {
    DateFormatToggle
  },
  created() {},
  mounted() {},
  props: {
    video: {
      type: Object,
      required: false,
      default: () => {}
    },
    output: {
      type: Object,
      required: false,
      default: () => {}
    },
    settings: {
      type: Object,
      required: false,
      default: () => {}
    },
    userData: {
      type: Object,
      required: false,
      default: () => {}
    },
    isManagementMode: {
      type: Boolean,
      default: false
    },
    myAppSettings_isDisplayActivity: {
      type: Boolean,
      default: false
    },
    myAppSettings_isDisplaySettings: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    videoURL() {
      return this.video && this.video.video && this.video.video.videoURL
        ? this.video.video.videoURL
        : null;
    },
    trigger() {
      return this.video && this.video.video && this.video.video.trigger
        ? this.video.video.trigger
        : null;
    },
    deviceName() {
      return this.video && this.video.deviceName ? this.video.deviceName : null;
    },
    createdAt() {
      return this.video && this.video._created_at
        ? this.video._created_at
        : null;
    },
    input() {
      return "";
    }
  },
  methods: {
    handleGenerateClick() {
      this.$emit("generate-click", this.input);
    },
    getThumURL() {
      //https://firebase.google.com/docs/storage/web/download-files#web-modular-api
      // Get the download URL
      getDownloadURL(starsRef)
        .then(url => {
          // Insert url into an <img> tag to "download"
        })
        .catch(error => {
          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case "storage/object-not-found":
              // File doesn't exist
              break;
            case "storage/unauthorized":
              // User doesn't have permission to access the object
              break;
            case "storage/canceled":
              // User canceled the upload
              break;

            // ...

            case "storage/unknown":
              // Unknown error occurred, inspect the server response
              break;
          }
        });
    }
  },
  data() {
    return {
      thumbURL: null
    };
  }
};
</script>

<style lang="scss" scoped></style>
